// extracted by mini-css-extract-plugin
export default {"root":"YearRangeEventGroup_root__3iSnU","listItem":"YearRangeEventGroup_listItem__KQGtb"};